import api from '../api'
export default {
  namespaced: true,
  state: {
    serverTypeList: [],
    serverTypeDetail: ''
  },
  mutations: {
    GET_SERVERTYPE_LIST (state, data) {
      data.forEach(item => {
        item.typeId = item.typeId + ''
      })
      state.serverTypeList = data
    },
    GET_SERVERTYPE_DETAIL (state, data) {
      state.serverTypeDetail = data
    }
  },
  actions: {
    GET_SERVERTYPE_LIST ({ commit, dispatch }, params) {
      return api.serverTypeList({
        params: params
      }).then((res) => {
        commit('GET_SERVERTYPE_LIST', res.payload)
        return res
      }).catch((rej) => {
        window.myVue.$message.error(rej.message)
      })
    },
    GET_SERVERTYPE_DETAIL ({ commit, dispatch }, config) {
      return api.serverTypeDetail(config).then((res) => {
        commit('GET_SERVERTYPE_DETAIL', res.payload)
        return res
      }).catch((rej) => {
        window.myVue.$message.error(rej.message)
      })
    },
    DELETE_SERVERTYPE ({ commit, dispatch }, params) {
      return api.deleteServerType({
        params: params
      }).then((res) => {
        return res
      }).catch((rej) => {
        window.myVue.$message.error(rej.message)
      })
    },
    ADD_SERVERTYPE ({ commit, dispatch }, config) {
      return api.addServerType(config).then((res) => {
        return res
      }).catch((rej) => {
        window.myVue.$message.error(rej.message)
      })
    },
    UPDATE_SERVERTYPE ({ commit, dispatch }, config) {
      return api.updateServerType(config).then((res) => {
        return res
      }).catch((rej) => {
        window.myVue.$message.error(rej.message)
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/serverTypeManage/store/index.js